<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
        :showEdit="false"
        :title="title"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        :key="open"
        @keydown.esc="reset(false)"
        @keydown.enter="triggerSubmit"
      >
        <Form
          ref="formOrder"
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :multiple="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import concept from "@/models/modelosDeLiquidacion/Relations/concept";
import concepts from "@/store/conceptos/concepts";
import relations from "@/store/autorizaciones/relations";
import Vue from "vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.concepts"),
      titleTable: "Roles_Conceptos",
      titleDelete: this.$tc("modelsLiquidations.toConceptToLiquidation"),
      isLoading: true,
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },

  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await relations.dispatch("getRolConcepts");
    await concepts.dispatch("getConcepts");
    this.isLoading = false;
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (!relations.state.concepts || relations.state.concepts.length === 0) {
        return []; // Return an empty array when conceptos doesn't exist or is falsy
      } else {
        return relations.state.concepts?.map((item) => {
          return item;
        });
      }
    },

    concepts() {
      return concepts.state.concepts;
    },

    conceptsSelected() {
      const editConcepts = this.editConcepts;
      return concepts.state.concepts.filter(
        (concept) =>
          !editConcepts?.some((selected) => selected.id === concept.conceptId)
      );
    },
    editConcepts() {
      return relations.state.concepts;
    },

    dataSelects() {
      return [
        {
          name: "idConcept",
          label: "Concepto",
          data: "",
          items: [],
          itemsValue: "conceptId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return relations.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return relations.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return relations.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    triggerSubmit() {
      if (this.$refs.formOrder) {
        this.$refs.formOrder.submitForm();
      }
    },
    async refreshItems() {
      if (relations.state.edit.id) {
        await relations.dispatch("getRolConcepts");
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.conceptsSelected;
          relations.commit("setMode", this.$tc("autoriz.addConceptToRol"));
          relations.commit("setOpen", true);
          break;
        case "delete":
          relations.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            rolId: relations.state.edit.id,
          };
          break;
        default:
          break;
      }
    },

    reset(value) {
      relations.commit("setOpen", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
        item.items = [];
      });
    },

    saveForm(items) {
      if (this.typeForm === "add") {
        return this.addConcept(items);
      }
    },

    async addConcept(form) {
      let payload = {
        idsConcepts: form.idConcept.split(",").map((id) => parseInt(id, 10)),
        rolId: relations.state.edit.id,
      };
      relations.commit("setNew", payload);
      relations
        .dispatch("addRolConcept")
        .then(() => {
          relations.dispatch("getRolConcepts");
          this.showAlert(this.$tc("autoriz.addConceptToRolSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("autoriz.errorConcept"), "#ff8d58");
        });
      this.reset(false);
    },

    deleteItem() {
      relations.commit("setItemDelete", this.itemToDelete);
      relations
        .dispatch("deleteRolConcept")
        .then(() => {
          this.openDelete = false;
          relations.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("autoriz.deleteConceptToRolSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("autoriz.errorConcept"), "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      relations.commit("setOpenDelete", false);
    },
  },
};
</script>
